import { render, staticRenderFns } from "./WfConsumerRecordRepair.vue?vue&type=template&id=a0d419c0&scoped=true&"
import script from "./WfConsumerRecordRepair.vue?vue&type=script&lang=js&"
export * from "./WfConsumerRecordRepair.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerRecordRepair.vue?vue&type=style&index=0&id=a0d419c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d419c0",
  null
  
)

export default component.exports